export const NOTIFICATIONS_SHOW_ERROR_TOAST = 'NOTIFICATIONS_SHOW_ERROR_TOAST';
export const NOTIFICATIONS_SHOW_SUCCESS_TOAST = 'NOTIFICATIONS_SHOW_SUCCESS_TOAST';
export const NOTIFICATIONS_SHOW_INFO_TOAST = 'NOTIFICATIONS_SHOW_INFO_TOAST';
export const NOTIFICATIONS_SHOW_ERROR_POPUP = 'NOTIFICATIONS_SHOW_ERROR_POPUP';
export const NOTIFICATIONS_SHOW_SUCCESS_POPUP = 'NOTIFICATIONS_SHOW_SUCCESS_POPUP';
export const NOTIFICATIONS_SHOW_INFO_POPUP = 'NOTIFICATIONS_SHOW_INFO_POPUP';
export const NOTIFICATIONS_DISMISS_POPUP = 'NOTIFICATIONS_DISMISS_POPUP';
export const NOTIFICATIONS_FETCH_PRE_REG_INVITE_STATUS = 'NOTIFICATIONS_FETCH_PRE_REG_INVITE_STATUS';
export const NOTIFICATIONS_FETCH_PRE_REG_INVITE_STATUS_SUCCESS = 'NOTIFICATIONS_FETCH_PRE_REG_INVITE_STATUS_SUCCESS';
export const NOTIFICATIONS_FETCH_PRE_REG_INVITE_STATUS_FAILURE = 'NOTIFICATIONS_FETCH_PRE_REG_INVITE_STATUS_FAILURE';
export const NOTIFICATIONS_CLEAR_PRE_REG_INVITE_STATUS = 'NOTIFICATIONS_CLEAR_PRE_REG_INVITE_STATUS';
export const NOTIFICATIONS_CLEAR_PRE_REG_INVITE_CAN_DISPLAY = 'NOTIFICATIONS_CLEAR_PRE_REG_INVITE_CAN_DISPLAY';
